import restful from '../vuex'
import axios from 'axios'
import { Message } from 'view-design'
import router from '@/router'
import { setToken, getToken } from '@/libs/util'

const state = {
  ...restful.states('editor'),
  access: '',
  unreadCount: 0,
  token: getToken(),
  me: {}
}

const getters = {
  ...restful.getters('editor'),
  me: (state) => state.me
}

const actions = {
  ...restful.actions('editors'),
  async login ({ commit }, params) {
    const response = await axios.post('sessions', params)
    commit('setToken', response.data.auth_token)
    commit('setChainStoreManner', response.data.chain_store_manner, { root: true })
    commit('me', response.data)

    Message.success('登录成功')

    router.replace('/')
  },
  async logout ({ commit }) {
    commit('setToken', '')
    commit('me', {})
    router.replace('/login')
  },
  async change_pwd ({ commit }, params) {
    const response = await axios.post('editors/change_password', params)

    commit('setToken', response.data.auth_token)
    commit('me', response.data)
  },
  async getUserInfo ({ state, commit }) {
    console.log(state)
    const response = await axios.get('sessions/me')
    commit('me', response.data)
    return response.data
  },
  getUnreadMessageCount () {
    return 10
  }
}

const mutations = {
  ...restful.mutations('editor'),
  me (state, me) {
    state.me = me
  },
  setToken (state, token) {
    state.token = token
    setToken(token)
  },
  setMessageCount (state, count) {
    state.unreadCount = count
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
